import GloLayout from 'lowcode/common/GloLayout';
import ClientComp from './ClientComp';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { loginType } = data;
    // const [isLogin, setIsLogin] = useState(false);

    // useEffect(() => {
    //     setIsLogin(getIsLogin());
    // }, []);

    return (
        <GloLayout id={id} className={`temp-member-ecocredits-banner temp-hide`}>
            <ClientComp loginType={loginType} />
        </GloLayout>
    );
}
